<script>
import UiInput from "./UiInput";

export default {
  name: "InputEmail",
  components: {
    UiInput,
  },
  props: ["value", "isInvalid", "placeholder"],
  data() {
    return {
      currentValue: this.value,
      isValid: false,
    };
  },
  methods: {
    onInput(value) {
      this.$emit("input", this.checkIfInvalid(value) ? value : null);
    },
    checkIfInvalid(value) {
      const isEmailValid = (email) => {
        return email.match(
          /^[a-zA-Z0-9_%+-]+(\.?[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9]+(?:[_-][a-zA-Z0-9]+)*(\.[a-zA-Z]{2,})+$/
        );
      };
      this.isValid = isEmailValid(value);
      return this.isValid;
    },
  },
};
</script>

<template>
  <div class="w-100 position-relative">
    <UiInput
      v-model="currentValue"
      :placeholder="placeholder"
      @input="onInput"
    />
    <div v-show="isValid" class="validation-check text-success">
      <i class="fa fa-check fa-lg" aria-hidden="true"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.validation-check {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
}
</style>
